import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

/** 当前用户（匿名 id + 额度）。Slice 9 用匿名 userId，P1 换真登录。 */
export const MeSchema = z.object({
  userId: IdSchema,
  activated: z.boolean(),
  credits: z.number().int().nonnegative(),
  inviteCode: z.string().nullable(),
});
export type Me = z.infer<typeof MeSchema>;

export const GetMeResponseSchema = MeSchema;
export type GetMeResponse = z.infer<typeof GetMeResponseSchema>;

/** 兑换邀请码 */
export const RedeemInviteRequestSchema = z.object({
  code: z.string().min(1).max(64),
});
export type RedeemInviteRequest = z.infer<typeof RedeemInviteRequestSchema>;

export const RedeemInviteResponseSchema = MeSchema;
export type RedeemInviteResponse = z.infer<typeof RedeemInviteResponseSchema>;

/** 额度流水条目（GET /api/usage 用，admin / 调试） */
export const UsageEntrySchema = z.object({
  id: z.number().int(),
  delta: z.number().int(),
  reason: z.enum(['redeem', 'batch_reserve', 'batch_refund', 'admin_grant']),
  batchId: z.string().nullable(),
  createdAt: TimestampSchema,
});
export type UsageEntry = z.infer<typeof UsageEntrySchema>;
